import type { ReactElement, ReactNode } from 'react';

import adminLoginBg from '../assets/admin-login-bg.png';

export function AuthPageShell({ children }: { children: ReactNode }): ReactElement {
  return (
    <main className="auth-page-shell">
      <img className="auth-page-bg" src={adminLoginBg} alt="" />
      <div className="auth-page-card">{children}</div>
    </main>
  );
}
